module.exports = __webpack_public_path__ + "img/steder_lapper_Kapp-Verde.e79e66e2.png";